var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.editMode)?_c('v-textarea',{ref:"textarea",attrs:{"error":_vm.field === _vm.fieldWithError,"disabled":_vm.disabled,"resize":"vertical","rows":"9"},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}}):_c('v-markdown',{staticClass:"markdown",attrs:{"content":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }